import LandingSlider from "areas/landing/elements/landing-slider"
import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const OtherCollections = () => (
  <Box mb={6}>
    <Box
      mb={2}
      pl={{ _: 4, tablet: 2 }}
      pr={2}
      textAlign={{ tablet: "center" }}
    >
      <SectionTitle>Other Collections</SectionTitle>
      <SectionDescription display={{ _: "none", tablet: "block" }}>
        Create the perfect {jewlr_t("terms.personalized")} gift.
      </SectionDescription>
    </Box>
    <LandingSlider
      element={{
        slider_type: "native",
        item_width: {
          _: "70vw",
          tablet: 4,
        },
        style: {
          bg: "#FFFFFF",
          mx: { tablet: "-16px" },
          pb: 3,
          pr: {
            tablet: "16px",
          },
        },
        arrow_style: {
          top: "31%",
        },
        items: [
          {
            countries: ["UK"],
            cta: {
              text: "Shop Now",
            },
            folder:
              "2020-new-landing-collections/for-her/rev-v2/mothers-necklaces",
            link: "/necklaces-for-mom",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Mother's Necklaces",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder:
              "2020-new-landing-collections/for-her/rev-v2/initial-necklaces",
            link: "/initial-necklaces",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Initial Necklaces",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v2/bar-necklaces",
            link: "/bar-necklaces",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Bar Necklaces",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder:
              "2020-new-landing-collections/for-her/rev-v2/birthstone-pendants",
            link: "/birthstone-pendants",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Birthstone Pendants",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder:
              "2020-new-landing-collections/for-her/rev-v2/everyday-necklaces",
            link: "/everyday-necklaces",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Everyday Necklaces",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v2/celtic",
            link: "/celtic-claddagh-jewelry",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Celtic and Claddagh",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v2/anklets",
            link: "/everyday-anklets",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Anklets",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v2/religious",
            link: "/religious-jewelry",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Religious",
            },
            type: "image",
          },
        ],
      }}
    />
  </Box>
)

export default OtherCollections
